module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-records"
  }, [_c('v-tabs', {
    attrs: {
      "fixed-tabs": "",
      "slider-color": "#ff2d55"
    },
    on: {
      "change": _vm.tabSelected
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v("\n        Approved\n      ")]), _vm._v(" "), _c('v-tab', [_vm._v("\n        Deleted\n      ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading && !_vm.records.length),
      expression: "loading && !records.length"
    }],
    staticClass: "loading-indicator center-block"
  }), _vm._v(" "), _c('records-list', {
    attrs: {
      "records": _vm.records
    },
    on: {
      "delete-record": _vm.handleRecordDelete,
      "restore-record": _vm.handleRecordRestore,
      "mark-record-relevance": _vm.markRecordRelevance,
      "clicked-record": _vm.showRecordDetails
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.records.length),
      expression: "!loading && records.length"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.calculateAmountPages('VIDEO'),
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        return _vm.fetchRecords('VIDEO')
      }
    },
    model: {
      value: (_vm.recordsPage),
      callback: function($$v) {
        _vm.recordsPage = $$v
      },
      expression: "recordsPage"
    }
  })], 1), _vm._v(" "), (_vm.imageRecords.length > 0) ? _c('div', [_c('h2', [_vm._v("Images")]), _vm._v(" "), _c('div', [_c('records-list', {
    attrs: {
      "records": _vm.imageRecords
    },
    on: {
      "delete-record": _vm.handleRecordDelete,
      "restore-record": _vm.handleRecordRestore,
      "mark-record-relevance": _vm.markRecordRelevance,
      "clicked-record": _vm.showRecordDetails
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.calculateAmountPages('IMAGE'),
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        return _vm.fetchRecords('IMAGE')
      }
    },
    model: {
      value: (_vm.recordsPage),
      callback: function($$v) {
        _vm.recordsPage = $$v
      },
      expression: "recordsPage"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedRecord) ? _c('record-details', {
    attrs: {
      "record": _vm.selectedRecord
    },
    on: {
      "clicked-similar-record": _vm.showRecordDetails,
      "close": function($event) {
        _vm.selectedRecord = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-377ec3e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserRecords.vue
// module id = 1031
// module chunks = 1